import { NavBarItem } from "./navbarItem";

export class NavBar {
  title: string;
  items: NavBarItem[];
  noOfNotifications?: any;
  type: string;
}